module.exports = __webpack_public_path__ + "images/patterns/dark/StripeHorizontal.ea8c1952355a4433ab2d.svg";